import { render, staticRenderFns } from "./MainCoin.vue?vue&type=template&id=306ca6e4&scoped=true&"
import script from "./MainCoin.vue?vue&type=script&lang=js&"
export * from "./MainCoin.vue?vue&type=script&lang=js&"
import style0 from "./MainCoin.vue?vue&type=style&index=0&id=306ca6e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306ca6e4",
  null
  
)

export default component.exports